import { render, staticRenderFns } from "./paperAdd.vue?vue&type=template&id=7bb45962&scoped=true&"
import script from "./paperAdd.vue?vue&type=script&lang=js&"
export * from "./paperAdd.vue?vue&type=script&lang=js&"
import style0 from "./paperAdd.vue?vue&type=style&index=0&id=7bb45962&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb45962",
  null
  
)

export default component.exports